import React from 'react';
import Localization from './Localization';

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <Localization />

      <img src="./img/T_MyPhoto_02.png" alt="My Photo" width="300" />

      <div className="sidebar-content-block">
        {/* Contacts */}
        <div className="contacts">
          <h3 className="sub-title text text-EN">Contacts</h3>
          <h3 className="sub-title text text-UA">Контакти</h3>

          <ul className="contact-items-block">
            <li className="contact-items">
              <a className="skills-item-title">+380505996096</a>
            </li>
            <li className="contact-items">
              <a className="sidebar-link" href="mailto:uginchus@gmail.com">
                uginchus@gmail.com
              </a>
            </li>
            <li className="contact-items">
              <a
                className="sidebar-link"
                href="https://www.linkedin.com/in/uginchus/"
              >
                Linkedin
              </a>
            </li>
          </ul>
        </div>

        {/* Hard Skills */}
        <div className="hard-skills">
          <h3 className="sub-title text text-EN">Hard Skills</h3>
          <h3 className="sub-title text text-UA">Технічні навички</h3>
          <h4 className="skills-item-title text text-EN">Programms</h4>
          <h4 className="skills-item-title text text-UA">Програми</h4>
          <ul className="skills-item">
            <li className="text text-EN">• Unreal Engine</li>
            <li className="text text-UA">• Unreal Engine</li>
            <li className="text text-EN">• Jenkins / Team City</li>
            <li className="text text-UA">• Jenkins / Team City</li>
            <li className="text text-EN">• Docs / Confluence</li>
            <li className="text text-UA">• Docs / Confluence</li>
            <li className="text text-EN">• Miro / Figma</li>
            <li className="text text-UA">• Miro / Figma</li>
            <li className="text text-EN">• Youtrack / Jira</li>
            <li className="text text-UA">• Youtrack / Jira</li>
            <li className="text text-EN">• Git / SVN / Perforce</li>
            <li className="text text-UA">• Git / SVN / Perforce</li>
          </ul>
          <h4 className="skills-item-title text text-EN">Languages</h4>
          <h4 className="skills-item-title text text-UA">Мови програмування</h4>
          <ul className="skills-item">
            <li className="text text-EN">• C++</li>
            <li className="text text-UA">• C++</li>
            <li className="text text-EN">• JavaScript</li>
            <li className="text text-UA">• JavaScript</li>
            <li className="text text-EN">• Python</li>
            <li className="text text-UA">• Python</li>
            <li className="text text-EN">• HTML / CSS</li>
            <li className="text text-UA">• HTML / CSS</li>
            <li className="text text-EN">• Batch</li>
            <li className="text text-UA">• Batch</li>
            <li className="text text-EN">• YAML</li>
            <li className="text text-UA">• YAML</li>
          </ul>
        </div>

        {/* Soft Skills */}
        <div className="soft-skills">
          <h3 className="sub-title text text-EN">Soft Skills</h3>
          <h3 className="sub-title text text-UA">М'які навички</h3>

          <ul className="skills-item">
            <li className="text text-EN">• Self-organizing</li>
            <li className="text text-UA">• Самоорганізація</li>
            <li className="text text-EN">• Teamwork</li>
            <li className="text text-UA">• Робота в команді</li>
            <li className="text text-EN">• Leadership</li>
            <li className="text text-UA">• Лідерські якості</li>
            <li className="text text-EN">• Critical thinking</li>
            <li className="text text-UA">• Критичне мислення</li>
            <li className="text text-EN">• Communication</li>
            <li className="text text-UA">• Комунікабельність</li>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
